@if (training && training.step==0) {
  <div class="training-step">
    <h3>{{training.name}}</h3>
    <div class="training-video" #player_container ></div>
    <div class="ui clearing segment training-stepper">
      <button [disabled]="!videoFinished && !training.definition?.videoWatched" (click)="videoWatched()" class="ui right floated primary button" translate>Next</button>
    </div>
  </div>
}
@if (training && question && training.step>0 && !training.finished) {
  <div class="training-step">
    <h3>{{training.name}}</h3>
    <div class="step-content">
      <p><span translate>Required Score</span>: <b>{{training.passingPercentile}}%</b></p>
      <p>
        <span translate>Question</span> {{training.step}} <span translate>of</span> {{training.definition.questions.length}}
        <h4>{{question.question | i18ntexttranslate}}</h4>
        <div class="ui list">
          @for (opt of question.options; track opt) {
            <div class="item ui radio checkbox">
              <input type="radio" name="answer" [(ngModel)]="question.selectedAnswerId" [value]="opt.id" />
              <label>{{opt.answer  | i18ntexttranslate}}</label>
            </div>
          }
        </div>
      </div>
      <div class="ui clearing segment training-stepper">
        @if (training.step>1) {
          <button (click)="prevStep()" class="ui primary button" translate>Back</button>
        }
        <button (click)="restartTraining()" class="ui primary button" translate>Rewatch Training Video</button>
        <button [disabled]="!question.selectedAnswerId" (click)="nextStep()" class="ui right floated primary button" translate>Next</button>
      </div>
    </div>
  }
  @if (training && training.finished) {
    <div  class="training-step">
      <h3>{{training.name}}</h3>
      <div class="step-content">
        <p class="final"><span translate>Required Score </span>: <b>{{training.passingPercentile}}%</b></p>
        <!--div class="bigcircle" [class.success]="training.successful">
        <div class="inner-circle">
          {{training.score}}%
        </div>
      </div-->
      <eup-donut [minpercent]="training.passingPercentile" [percent]="training.score"></eup-donut>
      @if (training.score<training.passingPercentile) {
        <p  class="final result"><span class="fail" translate>FAIL</span></p>
      }
      @if (training.score>=training.passingPercentile) {
        <p  class="final result"><span class="pass" translate>PASS</span></p>
      }
    </div>
    <div class="ui clearing segment training-stepper">
      <button (click)="retakeQuiz()" class="ui primary button" translate>Retake Quiz</button>
      <button (click)="restartTraining()" class="ui primary button" translate>Rewatch Training Video</button>
      <button [disabled]="!training.successful" class="ui right floated primary button" (click)="postTraining()" translate>Submit</button>
    </div>
  </div>
}
